import { useEffect, useState } from "react";
import dayjs from "dayjs";
import Modal from "@mui/material/Modal";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button } from "../../../../ui";
import closeIconModal from "../../../../assets/_CloseIconModal_.svg";
import { getAuditLogById } from "../../../../services/api/audit/AuditService";
import { IAuditLogDetail } from "../../../../@types/audit.type";
import styles from "./styles.module.scss";

interface AuditDetailModalProps {
  auditLogId: string;
  open: boolean;
  onClose: () => void;
}

export const AuditDetailModal: React.FC<AuditDetailModalProps> = ({ auditLogId, open, onClose }) => {
  const [detail, setDetail] = useState<IAuditLogDetail>();

  const loadDetail = async () => {
    try {
      const response = await getAuditLogById(auditLogId);
      setDetail(response.result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadDetail();
  }, [auditLogId]);

  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>Detalhe da Auditoria</h3>
          <Button onClick={onClose} className={styles.iconButton}>
            {closeIconModal && <img src={closeIconModal} alt="Fechar" />}
          </Button>
        </div>
        {detail && (
          <div className={styles.container}>
            <div className={styles.summary}>
              <p>
                <strong>Quando:</strong> {dayjs(detail.timestamp).format("DD/MM/YYYY HH:mm:ss")}
              </p>
              <p>
                <strong>Usuário:</strong> {detail.userName} {detail.userEmail ? `(${detail.userEmail})` : ""}
              </p>
              <p>
                <strong>Módulo:</strong> {detail.moduleName}
              </p>
              <p>
                <strong>Registro:</strong> {detail.entityDisplayName ?? detail.entityId}
              </p>
              <p>
                <strong>Resumo:</strong> {detail.actionDescription}
              </p>
            </div>

            {detail.changes.length > 0 && (
              <TableContainer component={Paper} className={styles.tableContainer}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Campo alterado</TableCell>
                      <TableCell>Valor anterior</TableCell>
                      <TableCell>Novo valor</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {detail.changes.map((change, index) => (
                      <TableRow key={index}>
                        <TableCell>{change.fieldLabel}</TableCell>
                        <TableCell>{change.oldValue ?? "-"}</TableCell>
                        <TableCell>{change.newValue ?? "-"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};
